import React from "react";
import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import FilterIcon from "../../../../assets/images/icons/FilterIcon";

const FilterSearchTh = ({
  tableThSearch,
  setTableThSearch,
  tableSearchInput,
  searchTerms,
  setSearchTerms,
  setSearchTermCount,
  setTableSearchInput,
  clearAllFilters,
}) => {
  const headerterm = Object.keys(searchTerms).length > 0;
  const [isFilterHovered, setIsFilterHovered] = useState(false);

  useEffect(() => {
    if (!tableThSearch) {
      setIsFilterHovered(false);
    }
  }, [tableThSearch]);

  const filterSearchTh = () => {
    if (tableThSearch) {
      setSearchTerms({});
      setSearchTermCount((prevCount) => prevCount + 1);
    }
    clearAllFilters();
    setTableSearchInput("");
    setTableThSearch(!tableThSearch);
  };
  return (
    <Tooltip
      placement="top"
      title="Filter"
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -5],
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "black",
            color: "white",
            boxShadow: "none",
            height: "23px",
            display: "flex",
            alignItems: "center",
          },
        },
      }}
    >
      <div>
        <button
          type="button"
          onClick={filterSearchTh}
          className={`tooltip relative hover:text-254155  ${tableThSearch ? "" : "text-2541558A"} `}
        >
          <FilterIcon isHovered={isFilterHovered} isActive={tableThSearch} />
          {(headerterm || tableSearchInput) && (
            <i className="bi bi-x absolute bottom-0 left-[13px] text-DF4321 text-[10px]"></i>
          )}
          {/* <span className={`tooltiptext text-[10px] w-[50px] bottom-full left-1/2 ml-[-25px]`}>Filter</span> */}
        </button>
      </div>
    </Tooltip>
  );
};

export default FilterSearchTh;
